import type { PdfContext } from "../types";

// Bloque(s) de imagen de las lentes (absolutePosition) y textos OD/OI
// superpuestos. Solo se emite si hay imagen capturada con tamaño suficiente.
// Devuelve un array de 0, 1 o 2 elementos para que el caller lo pueda spread
// dentro del content[].
export function buildLensesImageBlocks(ctx: PdfContext): any[] {
  const { imagenLente, textoOD, textoOI, fitLentes } = ctx;
  if (!imagenLente || imagenLente.length <= 5000) return [];

  const imageBlock = {
    absolutePosition: { x: 285, y: 279 },
    image: imagenLente,
    ...(fitLentes ? { fit: fitLentes } : {}),
  };

  if (!textoOD && !textoOI) return [imageBlock];

  const textBlock = {
    absolutePosition: { x: 285, y: 277 + (fitLentes ? fitLentes[1] - 18 : 0) },
    width: fitLentes ? fitLentes[0] : 250,
    stack: [
      ...(textoOD ? [{ text: textoOD, fontSize: 6.5, alignment: "center", color: "#333333" }] : []),
      ...(textoOI ? [{ text: textoOI, fontSize: 6.5, alignment: "center", color: "#333333" }] : []),
    ],
  };

  return [imageBlock, textBlock];
}
